<template>
    <div class="vue-accordion" :itemscope="isRich" :itemtype="isRich ? 'https://schema.org/FAQPage' : undefined">
        <div
            v-for="(item, index) in list"
            :key="index" class="item"
            :class="{ open: item.isOpen }" :id="item.slug"
            :itemscope="isRich"
            :itemprop="isRich ? 'mainEntity' : undefined"
            :itemtype="isRich ? 'https://schema.org/Question' : undefined"
        >
            <div class="label" :itemprop="isRich ? 'name' : undefined" @click="toggle(item, index)">{{ item.title }}</div>
            <div
                class="content"
                ref="content"
                :itemscope="isRich"
                :itemprop="isRich ? 'acceptedAnswer' : undefined"
                :itemtype="isRich ? 'https://schema.org/Answer' : undefined"
            >
                <div :itemprop="isRich ? 'text' : undefined" v-html="item.content"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
/* eslint-disable no-unused-expressions */
import { defineComponent, ref } from 'vue'
import { IProps, Item } from './type'

const slug = window.location.hash.replace('#', '')

export default defineComponent({
    props: ['accordion', 'richContent'],
    setup (props: IProps) {
        const content = ref<HTMLDivElement[]>([])
        const open = (el: HTMLDivElement) => { el.style.height = el.scrollHeight + 'px' }
        const close = (el: HTMLDivElement) => { el.style.height = '' }

        slug ? props.accordion.filter(i => i.slug === slug).forEach(i => { i.isOpen = true }) : false

        return {
            list: ref(props.accordion),
            isRich: props.richContent,
            content,
            toggle: (accordion: Item, index: number) => {
                accordion.isOpen = !accordion.isOpen
                const el = content.value[index]
                const url = accordion.isOpen ? '#' + accordion.slug : ' ' // https://stackoverflow.com/a/49373716/4000826
                accordion.isOpen ? open(el) : close(el)
                history.replaceState(null, '', url) // https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState
            },
        }
    },
})
</script>
